module.exports = __webpack_public_path__ + "img/home_title.970c0af8.png";